export default __webpack_public_path__ + "8d8a6192f886e3b5ba1a851fe0fd0d96.png";